// import Alerts from './Alerts';
import ToolsPage from './ToolsPage';

// export default Alerts;
export default ToolsPage;
